import React, { ReactElement, ReactNode } from 'react'
import { Flex } from 'theme-ui'

interface TableAndAccordionContainerProps {
  dataTestId: string
  children: ReactNode
}

function TableAndAccordionContainer({
  children,
  dataTestId,
}: TableAndAccordionContainerProps): ReactElement {
  return (
    <Flex
      data-testid={dataTestId}
      sx={{
        width: '100%',
        color: 'aliceBlue',
        flexDirection: 'column',
        border: ['none', '1px solid'],
        borderTop: ['1px solid', '1px solid'],
        borderBottom: ['1px solid', '1px solid'],
        borderRadius: [0, '1.2rem'],
        borderColor: ['blueYonder15', 'blueYonder15'],
        backgroundColor: 'cardBg',
      }}
    >
      {children}
    </Flex>
  )
}
export default TableAndAccordionContainer
